// DialogConfirm component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../common/icon_button/icon_button.jsx'
import Button from '../../common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Dialog from '../../../common/layout/dialog/dialog.jsx'

class DialogConfirm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.active,
      message: ''
    }

    this._references = {
      dialogConfirm: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onClose: PropTypes.func,
      type: PropTypes.string,
      showOk: PropTypes.bool,
      showCancel: PropTypes.bool,
      translateMessage: PropTypes.bool,
      active: PropTypes.bool,
      onClickOk: PropTypes.func,
      onClickNo: PropTypes.func,
      labelCancel: PropTypes.string,
      labelOk: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      message: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onClose: null,
      type: 'error',
      showOk: false,
      showCancel: false,
      translateMessage: true,
      active: false,
      labelOk: 'common.common.confirmOkButton',
      labelCancel: 'common.common.confirmCancelButton',
      onClickOk: null,
      onClickNo: null,
      title: '',
      subtitle: '',
      message: ''
    }
  }

  show (message = '') {
    this.setState({ active: true, message })
  }

  showMessage (message) {
    this.setState({ active: true, message })
  }

  hide = () => {
    this.setState({
      active: false,
      message: ''
    })
  }

  isActive () {
    return this.state.active
  }

  render () {
    const {
      title,
      subtitle,
      message: defaultMessage,
      type,
      labelOk,
      labelCancel,
      showOk,
      showCancel,
      translateMessage,
      onClickOk,
      onClickNo
    } = this.props
    const message = this.state.message || defaultMessage

    return (
      <Dialog
        className={`dialog-confirm dialog-confirm_${type}`}
        active={this.state.active}
        type='medium'
        onClose={this.hide} // eslint-disable-line react/jsx-handler-names
      >
        <div className='dialogwrap'>
          <div className='dialogheader'>
            <div className='col col_image'>
              {type === 'error' ? (
                <IconButton
                  icon='alert'
                  canHover
                  type='invert'
                  size='big'
                  hasBorder
                />
              ) : (
                <IconButton
                  icon='done'
                  canHover
                  type='invert'
                  size='big'
                  hasBorder
                />
              )}
            </div>
            <div className='col col_info'>
              <div className='title'>
                <IntlMessage ident={title} />
              </div>
              {subtitle && (
                <div className='subtitle'>
                  <IntlMessage ident={subtitle} />
                </div>
              )}
            </div>
            <div className='col col_action'>
              <IconButton
                icon='x'
                canHover
                type='default'
                size='big'
                onClick={this.hide} // eslint-disable-line react/jsx-handler-names
                className={type === 'error' ? ' error' : ' success'}
              />
            </div>
          </div>
          <div className='dialogcont'>
            <div className='message'>
              {translateMessage ? <IntlMessage ident={message} /> : message}
            </div>
          </div>
          <div className='dialogfooter'>
            {showOk && (
              <Button
                className='dialogbutton'
                type={type}
                title={labelOk}
                onClick={onClickOk}
              />
            )}
            {showCancel && (
              <Button
                className='dialogbutton'
                type='cancel'
                title={labelCancel}
                onClick={onClickNo || this.hide}
              />
            )}
          </div>
        </div>
      </Dialog>
    )
  }
}

export default DialogConfirm
